import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import DataCard from "../components/DataCard";

const groupByAttributes = (items) => {
  const grouped = items.reduce((acc, item) => {
    const key = `${item.title}-${item.category}-${item.wts || ""}-${
      item.size || ""
    }`;
    if (!acc[key]) {
      acc[key] = { ...item, quantity: 1, _groupKey: key };
    } else {
      acc[key].quantity += 1;
    }
    return acc;
  }, {});
  return Object.values(grouped);
};

const Home = ({ setUserName }) => {
  const [fetchError, setFetchError] = useState(null);
  const [stockDatas, setStockDatas] = useState([]);
  const [vetementsDatas, setVetementsDatas] = useState([]);
  const [objetsDatas, setObjetsDatas] = useState([]);
  const [billeterieDatas, setBilleterieDatas] = useState([]);
  const [pokemonDatas, setPokemonDatas] = useState([]);
  const [discordId, setDiscordId] = useState(null);
  const [currency, setCurrency] = useState("€");
  const [displayOrder, setDisplayOrder] = useState([]);

  const [searchQuery, setSearchQuery] = useState("");
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    let ownerId = params.get("id");

    if (!ownerId) {
      const rawQuery = location.search.slice(1);
      if (rawQuery) {
        ownerId = rawQuery;
      }
    }

    if (ownerId) {
      const API = params.get("id")
        ? `https://apiv2.notifyfrance.fr/public/id/${ownerId}`
        : `https://apiv2.notifyfrance.fr/public/${ownerId}`;

      fetch(API, { method: "GET" })
        .then((response) => {
          if (response.status === 403) throw new Error("Link disabled");
          if (response.status === 404) throw new Error("No items for sale");
          return response.json();
        })
        .then((data) => {
          const order = data.display
            ? data.display
                .replace(/\\/g, "")
                .replace(/"/g, "")
                .split(",")
                .filter(Boolean)
            : [
                "SNEAKERS",
                "VETEMENTS",
                "OBJETS",
                "POKEMON",
                "BILLETERIE",
                "SALAIRE",
              ];
          setDisplayOrder(order);

          if (data.username) {
            setUserName(data.username);
            setDiscordId(data.id);
            setCurrency(data.currency || "€");

            const loader = document.querySelector(".loader");
            const footer = document.querySelector(".footer");
            const searchbar = document.querySelector(".search-bar");
            const icon = document.querySelector(".icon");

            loader.style.display = "none";
            footer.style.display = "flex";
            icon.style.display = "block";
            searchbar.style.display = "block";
          }

          if (Array.isArray(data.items) && data.items.length > 0) {
            const stock = data.items
              .filter((item) => item.category === "SNEAKERS")
              .sort((a, b) => {
                const titleComparison =
                  a.title && b.title ? a.title.localeCompare(b.title) : 0;
                if (titleComparison !== 0) return titleComparison;
                const getSizeNumber = (size) => {
                  const match = size.match(/^(\d{1,2})/);
                  return match ? parseInt(match[1], 10) : 0;
                };
                return getSizeNumber(a.size) - getSizeNumber(b.size);
              });
            const vetements = data.items
              .filter((item) => item.category === "VETEMENTS")
              .sort((a, b) =>
                a.title && b.title ? a.title.localeCompare(b.title) : 0
              );
            const objets = Object.values(
              data.items
                .filter((item) => item.category === "OBJETS")
                .reduce((acc, item) => {
                  const key = item.articleobject || "autre";
                  if (!acc[key]) acc[key] = [];
                  acc[key].push(item);
                  return acc;
                }, {})
            ).flatMap((group) =>
              group.sort((a, b) =>
                a.title && b.title ? a.title.localeCompare(b.title) : 0
              )
            );
            const billeterieValide = data.items
              .filter((item) => item.category === "BILLETERIE")
              .filter((item) => !isNaN(new Date(item.dateevent).getTime()))
              .sort((a, b) => new Date(a.dateevent) - new Date(b.dateevent));
            const billeterieInvalide = data.items
              .filter((item) => item.category === "BILLETERIE")
              .filter((item) => isNaN(new Date(item.dateevent).getTime()));
            const billeterie = [...billeterieValide, ...billeterieInvalide];
            const pokemon = data.items
              .filter((item) => item.category === "POKEMON")
              .sort((a, b) =>
                a.title && b.title ? a.title.localeCompare(b.title) : 0
              );

            setStockDatas(groupByAttributes(stock));
            setVetementsDatas(groupByAttributes(vetements));
            setObjetsDatas(groupByAttributes(objets));
            setBilleterieDatas(groupByAttributes(billeterie));
            setPokemonDatas(groupByAttributes(pokemon));

            setFetchError(null);

            setTimeout(() => {
              updateVisuelCard();
            }, 15);
          } else {
            setFetchError("No items for sale");
          }
        })
        .catch((error) => {
          if (error.message === "Link disabled")
            setFetchError(
              "The page has been disabled by the stock owner. Contact him for more information."
            );
          else if (error.message === "No items for sale")
            setFetchError("No items for sale.");
          else if (error.message === "Too Many Requests")
            setFetchError("Too Many Requests.");
          else {
            console.error("Erreur lors de l'envoi des données:", error);
            setFetchError("An error occurred while retrieving data.");
          }
        });
    }
  }, [location.search, setUserName]);

  const filterData = (data) => {
    const query = searchQuery.toLowerCase();
    return data.filter(
      (item) =>
        item.title?.toLowerCase().includes(query) ||
        item.size?.toLowerCase().includes(query) ||
        item.category?.toLowerCase().includes(query) ||
        item.sku?.toLowerCase().includes(query)
    );
  };

  const categoryMap = {
    SNEAKERS: { label: "Sneakers", data: stockDatas },
    VETEMENTS: { label: "Clothes", data: vetementsDatas },
    OBJETS: { label: "Objects", data: objetsDatas },
    POKEMON: { label: "Pokemon", data: pokemonDatas },
    BILLETERIE: { label: "Tickets", data: billeterieDatas },
    SALAIRE: { label: "Salary", data: [] },
  };

  setTimeout(() => {
    updateVisuelCard();
  }, 15);
  return (
    <div className="page home">
      <div className="loader"></div>

      <div
        className="contact"
        onClick={() =>
          window.open(`https://discord.com/users/${discordId}`, "_blank")
        }
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="27"
          height="27"
          fill="currentColor"
          className="bi bi-discord"
          viewBox="0 0 16 16"
        >
          {" "}
          <path d="M13.545 2.907a13.2 13.2 0 0 0-3.257-1.011.05.05 0 0 0-.052.025c-.141.25-.297.577-.406.833a12.2 12.2 0 0 0-3.658 0 8 8 0 0 0-.412-.833.05.05 0 0 0-.052-.025c-1.125.194-2.22.534-3.257 1.011a.04.04 0 0 0-.021.018C.356 6.024-.213 9.047.066 12.032q.003.022.021.037a13.3 13.3 0 0 0 3.995 2.02.05.05 0 0 0 .056-.019q.463-.63.818-1.329a.05.05 0 0 0-.01-.059l-.018-.011a9 9 0 0 1-1.248-.595.05.05 0 0 1-.02-.066l.015-.019q.127-.095.248-.195a.05.05 0 0 1 .051-.007c2.619 1.196 5.454 1.196 8.041 0a.05.05 0 0 1 .053.007q.121.1.248.195a.05.05 0 0 1-.004.085 8 8 0 0 1-1.249.594.05.05 0 0 0-.03.03.05.05 0 0 0 .003.041c.24.465.515.909.817 1.329a.05.05 0 0 0 .056.019 13.2 13.2 0 0 0 4.001-2.02.05.05 0 0 0 .021-.037c.334-3.451-.559-6.449-2.366-9.106a.03.03 0 0 0-.02-.019m-8.198 7.307c-.789 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.45.73 1.438 1.613 0 .888-.637 1.612-1.438 1.612m5.316 0c-.788 0-1.438-.724-1.438-1.612s.637-1.613 1.438-1.613c.807 0 1.451.73 1.438 1.613 0 .888-.631 1.612-1.438 1.612" />{" "}
        </svg>
      </div>

      <div
        className="contact"
        onClick={() =>
          window.open(`https://nf-legit.me/${discordId}`, "_blank")
        }
        style={{ bottom: "75px" }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="lucide lucide-circle-check-icon lucide-circle-check"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="m9 12 2 2 4-4" />
        </svg>
      </div>

      {fetchError && (
        <p className="error-message" style={{ textAlign: "center" }}>
          {fetchError}
        </p>
      )}

      <div className="container-input">
        <span className="icon">🔍</span>
        <input
          type="text"
          className="search-bar"
          placeholder="Search by title, size, sku or category"
          onChange={(e) => setSearchQuery(e.target.value)}
        ></input>
      </div>

      <div className="datas">
        {displayOrder.map((category) => {
          const cat = categoryMap[category];
          if (!cat) return null;
          const filtered = filterData(cat.data);
          if (filtered.length === 0) return null;

          return (
            <div key={category}>
              <h2>{cat.label}:</h2>
              <div className="data-grid">
                {filtered.map((data) => (
                  <DataCard
                    key={data._groupKey}
                    data={data}
                    currency={currency}
                  />
                ))}
              </div>
            </div>
          );
        })}
      </div>

      <div className="footer">
        <p>© {new Date().getFullYear()} Notify Stock</p>
        <div style={{ display: "flex", gap: "2px", marginRight: "67px" }}>
          <a
            href="https://notify-france.fr/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Website
          </a>
          ·
          <a
            href="https://discord.gg/RfRTQq5Cme"
            target="_blank"
            rel="noopener noreferrer"
          >
            Discord
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;

function updateVisuelCard() {
  const minCardWidth = 115;
  const grids = document.querySelectorAll(".data-grid");

  grids.forEach((grid) => {
    const containerWidth = grid.clientWidth;
    const cardsPerRow = Math.max(1, Math.floor(containerWidth / minCardWidth));

    const cards = Array.from(grid.children).filter(
      (card) => !card.classList.contains("placeholder")
    );
    const visibleCards = cards.filter(
      (card) =>
        card.style.display !== "none" && card.style.visibility !== "hidden"
    );

    const remainder = visibleCards.length % cardsPerRow;
    let placeholders = Array.from(grid.getElementsByClassName("placeholder"));

    if (remainder === 0) {
      placeholders.forEach((p) => p.remove());
    } else {
      const needed = cardsPerRow - remainder;

      if (placeholders.length > needed) {
        placeholders
          .slice(0, placeholders.length - needed)
          .forEach((p) => p.remove());
      } else if (placeholders.length < needed) {
        for (let i = 0; i < needed - placeholders.length; i++) {
          const div = document.createElement("div");
          div.className = "data-card placeholder";
          div.style.visibility = "hidden";
          grid.appendChild(div);
        }
      }
    }
  });
}

window.addEventListener("resize", updateVisuelCard);
